<div [formGroup]="form" class="label-general-wrapper">
    <div class="informate_select_wrapper">
        <mat-label class="mat-label-general">
            <!-- Thread Type -->
            {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.THREAD_TYPE' | transloco }}
        </mat-label>

        <mat-select
            class="mat-select-general input-form-class"
            formControlName="threadType"
            name="thread_type"
            [class.spinner]="loading"
            (selectionChange)="selectthreadType($event)"
        >
            <mat-option class="option-list" *ngFor="let ttl of threadTypeList" [value]="ttl">{{ ttl }}</mat-option>
        </mat-select>
    </div>

    <div class="informate_select_wrapper">
        <mat-label class="mat-label-general">
            <!-- Bolt Size -->
            {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.BOLT_SIZE' | transloco }}
        </mat-label>

        <mat-select
            class="mat-select-general input-form-class"
            formControlName="boltSize"
            name="bolt_size"
            [class.spinner]="loadingBoltSize"
            (selectionChange)="selectBoltSize($event)"
        >
            <mat-option class="option-list" *ngFor="let bsl of boltSizeList" [value]="bsl.boltDimensionId">{{ bsl.boltSizeName }}</mat-option>
        </mat-select>
    </div>
</div>
